import {SaleSashPosition} from "../../config/constants"
import {isHomewareDepartment} from "../isHomewareDepartment"

export const showFitsIcons = (
    isOnSale: boolean,
    saleSashPosition: SaleSashPosition | null,
    department: string,
    displayFitIcons: boolean,
) =>
    !!saleSashPosition &&
    (!isOnSale || saleSashPosition === SaleSashPosition.TL || saleSashPosition === SaleSashPosition.TR) &&
    !isHomewareDepartment(department) &&
    displayFitIcons
